import { CalcMessage, MessageComponent } from "@/types/mySpace";
import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { ReactComponent as GoodNewsIcon } from "@/assets/icons/message/good-news.svg";
import { ReactComponent as DangerousNewsIcon } from "@/assets/icons/message/dangerous-news.svg";
import { ReactComponent as NormalNewsIcon } from "@/assets/icons/message/normal-news.svg";
import formatDate from "@/pages/Space/utils";

interface IMessageItem {
  massage: CalcMessage;
  setRead: (messageId: string | number) => void;
}

const MessageItem: React.FC<IMessageItem> = ({ massage, setRead }) => {
  const renderIcon = useMemo(() => {
    switch (massage.iconType) {
      case 1: {
        return <GoodNewsIcon />;
      }
      case 2: {
        return <DangerousNewsIcon />;
      }
      case 3:
      case 4:
      default: {
        return <NormalNewsIcon />;
      }
    }
  }, [massage]);

  const handleMsgClicked = () => {
    if (massage.isRead === 2) setRead(massage.msgId);
  };

  const renderMsgComponent = useMemo(() => {
    return (
      <div className={styles["msg-comp-wrapper"]}>
        {massage.msgComp.map((comp, idx) => (
          <span
            key={idx}
            onClick={comp.onClick ? comp.onClick : undefined}
            className={`${styles["msg-comp"]} ${
              comp.type === "link" ? styles["msg-comp-link"] : ""
            }`}
          >
            {comp.text}
          </span>
        ))}
      </div>
    );
  }, [massage]);

  const renderTime = useMemo(() => {
    return (
      <div className={styles["time-wrapper"]}>
        {formatDate(new Date(Number(massage.createTime) * 1000), "YYYY-MM-DD HH:ii:ss ")}
      </div>
    );
  }, [massage]);

  return (
    <div className={styles["message-item-wrapper"]} onClick={handleMsgClicked}>
      <div>{renderIcon}</div>
      <div className={styles["main-message-wrapper"]}>
        {renderMsgComponent}
        {renderTime}
      </div>
      {massage.isRead === 2 && <div className={styles["not-read"]}></div>}
    </div>
  );
};

export default MessageItem;
